import { useEffect, useState } from "react";
import Link from "next/link";

import { apiGet } from "@/services/api";

type VendorRow = {
  id: string;
  businessName: string;
  slug: string;
  description: string | null;
  vendorType: { name: string } | null;
  _count: { products: number };
};

export function StoresPage() {
  const [vendors, setVendors] = useState<VendorRow[]>([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    void apiGet<{ vendors: VendorRow[] }>(`/api/store${q ? `?q=${encodeURIComponent(q)}` : ""}`).then((d) =>
      setVendors(d?.vendors ?? []),
    );
  }, [q]);

  return (
    <div className="mx-auto max-w-amazon space-y-6 px-4 py-8">
      <h1 className="text-2xl font-black">Marketplace stores</h1>
      <p className="text-sm text-slate-600 dark:text-slate-300">
        Want to sell? <Link href="/sell" className="font-bold text-amazon-teal">Apply as a vendor</Link>
      </p>
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search stores…"
        className="w-full rounded border border-slate-300 px-4 py-2 dark:border-white/10 dark:bg-white/5"
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {vendors.map((v) => (
          <Link key={v.id} href={`/store/${v.slug}`} className="amazon-card block p-5 transition hover:shadow-md">
            <h2 className="text-lg font-black">{v.businessName}</h2>
            <p className="text-xs font-bold uppercase text-amazon-teal">{v.vendorType?.name ?? "Vendor"}</p>
            <p className="mt-2 line-clamp-2 text-sm text-slate-600 dark:text-slate-300">{v.description ?? ""}</p>
            <p className="mt-2 text-xs text-slate-500">{v._count.products} products</p>
          </Link>
        ))}
        {vendors.length === 0 && <p className="text-sm text-slate-500">No stores found.</p>}
      </div>
    </div>
  );
}
